import { Modal, Typography } from 'antd';

interface ConfirmationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLoading?: boolean;
  title?: string;
  description?: string;
}

const ConfirmationModal = ({
  open,
  onConfirm,
  onCancel,
  confirmLoading = false,
  title = 'Confirm Save',
  description = 'Are you sure you want to save these changes?',
}: ConfirmationModalProps) => (
  <Modal
    open={open}
    title={title}
    okText="Yes, Save"
    cancelText="Cancel"
    confirmLoading={confirmLoading}
    onOk={onConfirm}
    onCancel={onCancel}
    destroyOnHidden
  >
    <Typography.Text>{description}</Typography.Text>
  </Modal>
);

export default ConfirmationModal;
